import React, {Component} from "react";
import {connect} from "react-redux";

import * as loginActions from "../../../actions/loginActions";
import * as modelHelper from "../../../helpers/modelHelper";

import Modal, {MODAL_VARIANT_HEADERLESS} from "../generic/Modal";
import LoginForm from "../LoginForm";

class AuthenticationModal extends Component {
    logIn = (username, password) => {
        if (this.props.params.changeUser) {
            this.props.dispatchLogInAction(username, password);
        } else {
            this.props.dispatchAuthenticateUserAction(username, password, this.props.params.next);
        }
    };

    render() {
        return (
            <Modal
                modalId={this.props.id}
                variant={MODAL_VARIANT_HEADERLESS}
                content={modelHelper.buildModalSection(
                    <LoginForm logIn={this.logIn} verifyPasswordOnly={!this.props.params?.changeUser ?? true} />
                )}
            />
        );
    }
}

const mapStoreToProps = () => {
    return {};
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchAuthenticateUserAction: (username, password, next) => {
            dispatch(loginActions.authenticateUser(username, password, next));
        },
        dispatchLogInAction: (username, password) => {
            dispatch(loginActions.logInAsAnotherUser(username, password));
        }
    };
};

export default AuthenticationModal = connect(mapStoreToProps, mapDispatchToProps)(AuthenticationModal);
